<ng-container>
  <button
    type="button"
    class="nav-menu__dropdown"
    [testId]="'dropdown-' + controlsId"
    [attr.aria-expanded]="isOpen"
    [attr.aria-controls]="controlsId"
    [attr.aria-label]="label"
    [attr.data-state]="isOpen ? 'open' : 'closed'"
    (click)="handleClick($event)"
  >
    <span class="visually-hidden">{{ label }}</span>
    <svg width="16" height="16" viewBox="0 0 16 16" class="nav-menu__dropdown-icon">
      <path d="M2 6l6 6 6-6" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  </button>
</ng-container>
